<div class="cell-wrapper">
  <button nz-dropdown nzTrigger="click" [nzDropdownMenu]="menu" class="dropdownButton">
    <svg-icon src="assets/icons/ellipsis.svg" class="selected-icon"></svg-icon>
  </button>

  <nz-dropdown-menu class="menu-options" #menu="nzDropdownMenu">
    <ul nz-menu>
      <ng-container *ngFor="let item of actions">
        <li
          *ngIf="!item.divider && this.shouldShowAction(params, item)"
          nz-menu-item
          class="menu-item"
          [nzDisabled]="this.shouldDisableAction(params, item)"
          [class.disabled-menu-icon]="this.shouldDisableAction(params, item)"
          [class.gap-locked]="deniedReason(item) !== null"
          nz-tooltip
          nzTooltipPlacement="left"
          [nzTooltipTitle]="deniedReason(item)"
          tabindex="0"
          (click)="run(params, item)"
          (keydown.enter)="run(params, item)"
          (keydown.space)="run(params, item)"
        >
          <span *ngIf="deniedReason(item); else icon" class="gap-lock" aria-hidden="true"></span>
          <ng-template #icon><svg-icon *ngIf="item.icon" [src]="'assets/icons/' + item.icon" class="option-icon"></svg-icon></ng-template>
          {{ item.label }}
        </li>
        <li *ngIf="item.divider" nz-menu-divider></li>
      </ng-container>
    </ul>
  </nz-dropdown-menu>
</div>
